import React, { Component, Fragment } from 'react';
import { node, string, any, arrayOf, shape, bool, oneOfType, Element } from 'prop-types';
import { GetApp } from '@material-ui/icons';
import html2canvas from 'html2canvas';
import styles from './style.scss';

const PNG = 'PNG';
const JPG = 'JPG';
const CSV = 'CSV';
const IMAGE_TYPE = {
  [PNG]: 'image/png',
  [JPG]: 'image/jpeg'
}
const DEFAULT_FILENAME = 'download';

export default class ModuleExport extends Component {
  static propTypes = {
    exportImg: oneOfType([node, shape({current: Element})]),
    scrollableChild: oneOfType([node, shape({current: Element})]),
    fileName: string,
    data: arrayOf(any),
    disableCsvExport: bool,
    disablePngExport: bool,
    disableJpgExport: bool,
    exportIconStyle: shape({any}),
    exportItemsStyle: shape({any}),
    exportContainerStyle: shape({any}),
  }

  downloadLink = React.createRef();
  exportImage = (type) => () => {
    const { exportImg, fileName, scrollableChild } = this.props;
    let canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    const fileType = IMAGE_TYPE[type];
    const image = exportImg.current || exportImg;
    const svgElements = image.querySelectorAll('svg');
    const elementUpdateStatus = [];
    const scrollableContainer = scrollableChild && scrollableChild.current || scrollableChild;
    let scrollableContainerHeight = null;
    let scrollableContainerWidth = null;

    if (scrollableContainer) {
      const containerStyle = window.getComputedStyle(scrollableContainer);
      scrollableContainerHeight = scrollableContainer.getAttribute('height') || containerStyle.height;
      scrollableContainerWidth = scrollableContainer.getAttribute('width') || containerStyle.width;
      scrollableContainer.style.height = 'auto';
      scrollableContainer.style.width = 'auto';
    }

    svgElements.forEach((element) => { //set style for svg element
      elementUpdateStatus.push({
        height: element.hasAttribute('height'),
        width: element.hasAttribute('width'),
        fill: element.hasAttribute('fill')
      });
      const style = window.getComputedStyle(element);
      const fillColor = element.getAttribute('fill') || style.color;
      element.setAttribute('width', '100%');
      element.setAttribute('height', '100%');
      element.setAttribute('fill', fillColor);
    });

    html2canvas(image, { //change html element to canvas
      allowTaint: true,
      useCORS: true,
      imageTimeout: 0
    }).then((element) => {
      const { height, width } = element;
      canvas.height = height;
      canvas.width = width;
      context.drawImage(element, 0, 0, width, height); 
      const dataURL = canvas.toDataURL(fileType, 1);
      const downloadLink = this.downloadLink.current;
      downloadLink.href = dataURL;
      downloadLink.download = fileName || DEFAULT_FILENAME;
      downloadLink.target = "_blank";
      downloadLink.click();
      canvas = null;
      return;
    });

    if (scrollableContainer) {
      scrollableContainer.style.height = scrollableContainerHeight;
      scrollableContainer.style.width = scrollableContainerWidth;
    }

    svgElements.forEach((element, index) => { //remove attribute if it's not originally exist
      !elementUpdateStatus[index].height && element.removeAttribute('height');
      !elementUpdateStatus[index].width && element.removeAttribute('width');
      !elementUpdateStatus[index].fill && element.removeAttribute('fill');
    });
  }

  exportCSV = () => {
    const { data, fileName } = this.props;
    const csvData = data.reduce((accumulator, rowParts, rowIndex) => {
      const isHeader = rowIndex === 0;
      const csvRow = rowParts.reduce((row, entryValue, index) => {
        const isString = typeof entryValue == 'string' || entryValue instanceof String;
        const cleanedEntryValue = !isHeader && isString ? `"${entryValue.replace(/"/g, '""')}"` : entryValue;
        const newRow = `${row}${cleanedEntryValue}${ index < rowParts.length - 1 ? ',' : '' }`;
        return newRow;
      }, '');
      const newAccumlator = `${accumulator}${csvRow}\n`;
      return newAccumlator;
    }, '');
    const downloadLink = this.downloadLink.current;
    downloadLink.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csvData);
    downloadLink.download = fileName && `${fileName}.csv` || `${DEFAULT_FILENAME}.csv`;
    downloadLink.target = "_blank";
    downloadLink.click();
  }

  drawDownloadOptions () {
    const { disableCsvExport, disablePngExport, disableJpgExport } = this.props;
    return (
      <Fragment>
        {!disableCsvExport && <div data-test="exportCSVBtn" className={styles.exportItem} onClick={this.exportCSV}>{CSV}</div>}
        {!disablePngExport && <div data-test="exportPNGBtn" className={styles.exportItem} onClick={this.exportImage(PNG)}>{PNG}</div>}
        {!disableJpgExport && <div data-test="exportJPGBtn" className={styles.exportItem} onClick={this.exportImage(JPG)}>{JPG}</div>}
      </Fragment>
    )
  }

  render () {
    const { 
      exportIconStyle, 
      exportItemsStyle, 
      exportContainerStyle,
    } = this.props;
    return (
      <div data-test="downloadBtn" className={styles.exportContainer} style={exportContainerStyle}>
        <Fragment>
          <div className={styles.exportIcon} style={exportIconStyle}>
            <GetApp className={styles.getAppIcon} />
          </div>
          <div className={styles.exportItemsContainer} style={exportItemsStyle}>
            {this.drawDownloadOptions()}
          </div>
          <a ref={this.downloadLink} className={styles.displayNone} />
        </Fragment>
      </div>
    )
  }
}
